import './progress-bar-indicator.cs.css';
import React from 'react';
import { Step, Stepper } from 'react-form-stepper';

interface ProgressBarIndicatorDatamodel {
  labels: string[];
  currentIndex: number;
}

const ProgressBarIndicator = (dataModel: ProgressBarIndicatorDatamodel) => {
  return (
    <div style={{ direction: 'ltr', width: '100%' }}>
      <Stepper
        activeStep={dataModel.currentIndex}
        styleConfig={{
          inactiveBgColor: '#D1D1D1',
          activeBgColor: '#EE9E2B',
          completedBgColor: '#299764',
        }}
      >
        {dataModel.labels.map((item, index) => (
          <Step
            label={
              <span
                style={{
                  fontSize: '15px',
                  color:
                    index < 3 ? '#299764' : index === 3 ? '#EE9E2B' : '#D1D1D1',
                }}
              >
                {item}
              </span>
            }
          />
        ))}
      </Stepper>
    </div>
  );
};

export default ProgressBarIndicator;
